var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0,
    width: 25,
    height: 13,
    rx: 6.5,
    fill: "#e20312"
  }))), /*#__PURE__*/React.createElement("g", {
    "aria-label": "S4",
    style: {
      transform: "translate(0.5px, 0)",
      fontWeight: "bold",
      fontSize: 10,
      fontFamily: "HelveticaNeue-Bold, 'Helvetica Neue', sans-serif",
      fill: "#fff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 6.7149999,7.63 h 1.52 q 0,0.67 0.48,1.02 0.41,0.3 1.1,0.3 0.5400001,0 0.9000001,-0.17 0.49,-0.23 0.49,-0.72 0,-0.61 -1.1,-0.92 Q 8.2049999,6.6 8.0549999,6.52 q -1.1,-0.53 -1.1,-1.67 0,-1.03 0.85,-1.63 0.76,-0.53 1.82,-0.53 1.2300001,0 1.9900001,0.53 0.87,0.61 0.87,1.77 h -1.52 q -0.06,-1.08 -1.4100001,-1.08 -0.43,0 -0.73,0.18 -0.35,0.22 -0.35,0.63 0,0.39 0.39,0.57 0.3,0.14 1.7400001,0.51 0.84,0.21 1.25,0.48 0.87,0.56 0.87,1.6 0,1.02 -0.76,1.64 -0.8,0.65 -2.2100001,0.65 -1.29,0 -2.12,-0.61 -0.93,-0.69 -0.92,-1.93 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.084983,10 V 8.38 h -2.96 v -1.3 l 3.04,-4.08 h 1.27 v 4.21 h 0.93 v 1.17 h -0.93 V 10 Z m 0,-2.79 V 4.78 h -0.03 l -1.81,2.43 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.50bb56a834dc46cc701bb0c77d09d56f.svg";
export { ForwardRef as ReactComponent };